import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PromoBar from "@/components/PromoBar";
import WeeklyThemeBanner from "@/components/WeeklyThemeBanner";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Videos from "@/components/sections/Videos";
import FinalCTA from "@/components/sections/FinalCTA";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "VideoGallery",
  name: "Vídeos e Mensagens de Carlos Medeiros",
  description:
    "Mensagens curtas, pregações e reflexões em vídeo para acompanhar seu dia.",
};

export default function VideosPage() {
  useDocumentMeta({
    title: "Vídeos e Mensagens, Carlos Medeiros",
    description:
      "Assista mensagens em vídeo, pregações e reflexões pastorais que fortalecem a fé.",
    canonical: "https://cemedeiros.com.br/videos",
    url: "https://cemedeiros.com.br/videos",
    jsonLd: JSON_LD,
  });
  return (
    <div data-testid="videos-page" className="bg-mist min-h-screen">
      <PromoBar />
      <WeeklyThemeBanner mode="top" />
      <Navbar />
      <main className="pt-32">
        <Videos />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
